/**
 * The `<main>` of a screen outside the shell (TMMAPP-0081, A11Y): a sign-in interstitial, the
 * referral and shared-virtual-account landings. It is the one `main` on its page, `id="main"` and
 * focusable so the skip link (the shell's own `SkipLink`, placed first here) lands on it. Pages
 * inside `AppShell` never use it — the shell already owns their `main` and skip link.
 */
import type { ReactNode } from 'react';
import { Container, type ContainerProps } from '@mui/material';
import { MAIN_ID, SkipLink } from './SkipLink';

interface StandaloneMainProps {
  maxWidth?: ContainerProps['maxWidth'];
  sx?: ContainerProps['sx'];
  children: ReactNode;
}

export function StandaloneMain({ maxWidth = 'sm', sx, children }: StandaloneMainProps) {
  return (
    <>
      <SkipLink />
      <Container
        component="main"
        id={MAIN_ID}
        tabIndex={-1}
        maxWidth={maxWidth}
        sx={[{ '&:focus': { outline: 'none' } }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        {children}
      </Container>
    </>
  );
}
